import React from 'react';

export const ContainerStyles: React.CSSProperties = {
	minHeight: '100vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
	padding: 24,
};

export const ContainerCardStyles: React.CSSProperties = {
	width: '100%',
	maxWidth: 400,
	boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
};

export const ContainerCard_BodyStyles: React.CSSProperties = {
	padding: '40px 32px',
};

export const TitleContainerStyles: React.CSSProperties = {
	textAlign: 'center',
	marginBottom: 32,
};

export const TitleStyles: React.CSSProperties = {
	marginBottom: 8,
};

export const RegisterBtnStyles: React.CSSProperties = {
	marginBottom: 16,
};

export const LoginRedirectStyles: React.CSSProperties = {
	textAlign: 'center',
};
